const translations = { title: 'Place level settings' }

export default translations
